import React from "react";

const ReservationListModal = ({
  open,
  onClose,
  reservations,
  onAccept,
  onCancel,
}) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-md max-h-[90vh] overflow-y-auto mx-4">
        {/* Header */}
        <div className="sticky top-0 bg-gradient-to-r from-orange-600 to-orange-700 px-6 py-4 rounded-t-xl shadow-md">
          <div className="flex justify-between items-start">
            <div>
              <h2 className="text-xl font-bold text-white mb-1 flex items-center gap-2">
                <svg
                  className="w-6 h-6"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z" />
                  <path
                    fillRule="evenodd"
                    d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z"
                    clipRule="evenodd"
                  />
                </svg>
                Reservation Lists
              </h2>
              <h4 className="text-sm text-orange-100 font-medium">
                {new Date().toLocaleDateString("en-IN", {
                  weekday: "long",
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                })}
              </h4>
            </div>
            <button
              onClick={onClose}
              className="text-white hover:text-orange-100 transition-colors p-1 hover:bg-white/20 rounded-lg"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="p-6">
          {reservations.length === 0 ? (
            <p className="text-center text-gray-500 py-8">No reservations</p>
          ) : (
            <div className="space-y-3">
              {reservations.map((r) => (
                <div
                  key={r._id}
                  className={`border rounded-lg p-4 flex justify-between items-center gap-3 ${
                    r.status === "accepted"
                      ? "bg-green-50 border-green-200"
                      : r.status === "cancelled"
                        ? "bg-red-50 border-red-200"
                        : "bg-white border-gray-200"
                  }`}
                >
                  <div className="flex-1">
                    <div className="font-semibold text-gray-800">{r.name}</div>
                    <div className="text-sm text-gray-600">({r.phone})</div>
                    <div className="text-sm text-gray-600 mt-1">
                      Table: {r.tableNumber}
                    </div>
                    <div className="text-sm text-gray-600">Time: {r.time}</div>
                  </div>

                  <div className="flex gap-2">
                    {r.status === "pending" && (
                      <>
                        <button
                          onClick={() => onAccept(r)}
                          className="px-3 py-1.5 bg-green-600 hover:bg-green-700 text-white text-sm font-medium rounded-lg transition-colors"
                        >
                          Accept
                        </button>
                        <button
                          onClick={() => onCancel(r)}
                          className="px-3 py-1.5 bg-red-600 hover:bg-red-700 text-white text-sm font-medium rounded-lg transition-colors"
                        >
                          Cancel
                        </button>
                      </>
                    )}

                    {r.status === "accepted" && (
                      <span className="px-3 py-1.5 bg-green-600 text-white text-xs font-semibold rounded-lg uppercase">
                        Accepted
                      </span>
                    )}

                    {r.status === "cancelled" && (
                      <span className="px-3 py-1.5 bg-white text-red-600 border border-red-600 text-xs font-semibold rounded-lg uppercase">
                        Cancelled
                      </span>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}

          <button
            onClick={onClose}
            className="w-full mt-6 px-4 py-3 bg-gradient-to-r from-gray-600 to-gray-700 hover:from-gray-700 hover:to-gray-800 text-white font-semibold rounded-lg shadow-lg hover:shadow-xl transition-all transform hover:scale-[1.02]"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReservationListModal;
